module.exports = __webpack_public_path__ + "static/media/TCc.d249606b.jpg";